<template>
    <div class="flex flex-wrap">
       <!-- <pre> {{inventoryList[0]}}</pre> -->
      <vs-card class="cstm-asset-card relative" v-for="(eachList, index) in inventoryList" :key="index">
        <vs-dropdown
                v-if="checkEditPermission || checkDeletePermission"

        >
          <vs-button class="btn-drop" type="border" icon="more_vert"></vs-button>

          <vs-dropdown-menu

          >
            <vs-dropdown-item
                                  v-if="checkEditPermission"

            >
              <a @click="editInventory(eachList, index)">
                <!-- <feather-icon icon="EditIcon" style="width: 16px; color: green" /> -->
                Edit
              </a>
            </vs-dropdown-item>
            <vs-dropdown-item
                        v-if="checkDeletePermission"

            >
              <a
              @click="deleteRoom(eachList.assets_id,index)">
                <!-- <feather-icon icon="TrashIcon" style="width: 16px; color: red" /> -->
                Delete
              </a>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
            <img
              v-if="eachList.defaultImage.length"
              class="room-img"
              :src="eachList.defaultImage[0].files_details.file_path"
            />
            <img
            v-else
              class="room-img"
              src="https://maestroselectronics.com/wp-content/uploads/2017/12/No_Image_Available.jpg"
            />
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" class="py-4">
              <div class="flex flex-wrap items-center">
               
                <h3  @click="inventoryDetails(index)" style="width: 90%;" class="cursor-pointer">
                  {{ eachList.name }}
                </h3>
                <div v-if="getInventoryName(eachList.inventory_type) == 'Removable'" class="numbers py-2">
                  <span class="material-icons">inventory</span>
                  <span>Quantity {{ eachList.quantity }}</span>
                </div>
              </div>
              {{eachList.category_name}}
              <p class="w-full my-4">
                
                {{eachList.asset_details}}
              </p>
              <!-- <vs-list>
                <span class="material-icons">menu_book</span>
                <h4>Suitable For</h4>
                <vs-list-item
                  :title="eachSuitable"
                  v-for="(eachSuitable, index) in eachList.suitable"
                  :key="index"
                ></vs-list-item>
                <vs-list-item title="Some more text"></vs-list-item>
              </vs-list> -->
              <vs-row class="mb-6">
                <vs-col vs-type="flex" vs-align="" vs-lg="6" vs-xs="12" class="px-1">
                  <ul class="assets-list mt-2">
                    <div class="flex items-center">
                      <span class="material-icons">menu_book</span>
                      <h6 class="heading">Suitable For:</h6>
                    </div>
                    <li
                      :title="eachSuitable.tag_name"
                      v-for="(eachSuitable, index) in eachList.asset_tags"
                      :key="index"
                    >{{eachSuitable.tag_name}}</li>
                  </ul>
                </vs-col>
                <vs-col vs-type="flex" vs-align="" vs-lg="6" vs-xs="12" class="px-1">
                  <ul class="assets-list mt-2">
                    <div class="flex items-center">
                      <span class="material-icons">inventory</span>
                      <h6 class="heading">Inventory Type:</h6>
                    </div>
                    <li>{{getInventoryName(eachList.inventory_type)}}</li>
                  </ul>
                </vs-col>
              </vs-row>
          </vs-col>
        
          <!-- <vs-col vs-type="flex" vs-align="" vs-w="4" class="px-4">
            <div style="display: block">
              <div class="flex items-center">
                <h3 class="mr-1">&#163;  {{ eachList.price }}</h3>
                <span>/ {{ eachList.booking_time }}</span>
              </div> -->
              <!-- <vs-list>
                <h4>Inventory</h4>

                <vs-list-item
                  :title="eachInventory"
                  v-for="(eachInventory, index) in eachList.inventory"
                  :key="index"
                ></vs-list-item>
              </vs-list> -->
            <!--   <ul class="assets-list">
                <div class="flex items-center">
                  <span class="material-icons">music_note</span>
                  <h5 class="heading">Inventory:</h5>
                </div>
                <li
                  :title="eachInventory"
                  v-for="(eachInventory, index) in eachList.inventory_array"
                  :key="index"
                >{{eachInventory.name}}</li>
              </ul> -->
            <!-- </div>
          </vs-col> -->
        </vs-row>
        <h3 class="inventory-price"><b><span v-html="currency_code"></span>{{ eachList.price }}</b></h3>
      </vs-card>
    </div>

</template>

<script>
import {deleteInventoryApi} from  '@/api/room'
export default {
  data () {
    return {
      currency_code:JSON.parse(localStorage.getItem('localization'))
        .currency.currency_symbol
    }
  },
  props:{
    inventoryList:{
      type:Array,
      required:true,
      default:() => []
    },
    checkEditPermission:{},
    checkDeletePermission:{}
  },
  methods:{
    editInventory (eachList) {
      
      this.$emit('editList', eachList)

    },
    
    async deleteRoom (assetsId, index) {
      const assets_id = [assetsId]
      try {
        const payload = {
          customer_id : this.$store.getters.customerId,
          asset_types : 'Inventory',
          assets_id
        }

        const data = await deleteInventoryApi(payload)
        
        this.showSuccessMessage(
          'success',
          'Deleted Successfully',
          'success'
        )
        this.$emit('deleteInventory', index)
      } catch (error) {
        
        this.showSuccessMessage(
          'success',
          'Something Went Wrong',
          'danger'
        )
      }

    },
    getInventoryName (type) {
      if (type === 0) {
        return 'Removable'
      }  else if (type === 1) {
        return 'Non Removable'
      } else {
        return 'None'
      }
    },
    inventoryDetails (index) {
      
      
      this.$router.push({
        name: 'inventory-details',
        params: {inventoryDetail: this.inventoryList[index]}
      })
    }
  }
        
}
</script>

<style>
  .inventory-price {
    position: absolute;
    right: 18px;
    bottom: 20px;
  }
  .cstm-asset-card .numbers {
    min-width: 180px;
  }
</style>